import React from "react";
import { NavbarLoggedIn } from "../components/NavbarSignedIn.jsx";
import { Footer } from "../components/Footer.jsx";
import Impressum from "./PaminaDSGVO/Impressum.tsx";
// import "./listing.css";
import { IconUser2 } from "../icons/IconUser2.jsx";

export default function ImpressumPage({ supabase }) {
    return (
        <div className="web-listing">
            <NavbarLoggedIn supabase={supabase} icon={<IconUser2 className="icon-user-2" />} />
            <Impressum mail="info@pamina.ai"/>
            <div className="web-listing-v">
                <Footer />
            </div>
        </div>
    );
};
